<script>
  import { actions } from '../../utils/actions';
  import { SPRITESHEET_URL } from '../../utils/constants.ts';
  import { getPath } from '../../utils/imageKit.ts';
  import BaseLink from '../BaseLink/BaseLink.svelte';
  import { closeHeaderMenu } from '../../stores/headerMenu.ts';

  let {
    title,
    icon = {
      url: undefined,
      alt: undefined,
    },
    menuItems = [],
    a11yHelpTemplate,
    dataTestId = 'irx-the-header-expander',
    path = '',
  } = $props();

  let showDropdown = $state(false);
  const toggleDropdown = () => {
    showDropdown = !showDropdown;
  };

  // Handle Image Setup
  const defaultSrc = getPath(icon, { w: 32, ar: '1:1' });
  const highResSrc = getPath(icon, { w: 32, ar: '1:1' }, 2);
</script>

<button
  onclick={toggleDropdown}
  data-testid={dataTestId}
  class="w-full bg-white text-blue-cerulean hover-hover:hover:underline hover-hover:hover:text-blue-darkish active:underline active:text-blue-darkish
  focus:relative focus:outline-hidden active:shadow-inset-active focus:shadow-inset-focus"
  class:bg-gray-reddish={showDropdown}
  aria-label={a11yHelpTemplate.replace(/{{ITEMS}}/, menuItems.length).replace(/{{TITLE}}/, title)}
  aria-haspopup="menu"
  aria-expanded={showDropdown}
>
  <div
    class="flex items-center py-5 pr-4 border-b border-gray-opaque-charcoal"
    class:pl-6={!showDropdown}
    class:pl-0={showDropdown}
    class:ml-6={showDropdown}
  >
    <span class="w-8 h-8">
      {#if icon && icon.url && icon.alt}
        <img
          class="block w-8 h-8"
          width="32"
          role="presentation"
          src={defaultSrc}
          alt={icon.alt}
          srcset={`${defaultSrc}, ${highResSrc} 2x`}
          sizes="32px"
        />
      {/if}
    </span>
    <span class="grow px-6 text-lg font-semibold text-left">{title}</span>
    <span class="w-8 h-8 shrink-0">
      <svg
        class="w-full h-full fill-current rotate-90 transition-transform duration-150 ease-in"
        class:-rotate-90={showDropdown}
      >
        <use xlink:href={`${SPRITESHEET_URL}chevron-right`} />
      </svg>
    </span>
  </div>
</button>
<ul
  class="bg-gray-reddish overflow-hidden transition-all duration-150 ease-in"
  class:max-h-0={!showDropdown}
  class:max-h-120={showDropdown}
>
  {#each menuItems as item, index (index)}
    <li>
      {#if item.url}
        {#if path === item.url || path === `${item.url}/`}
          <button
            class="w-full flex items-center px-6 py-5 text-blue-cerulean hover-hover:hover:underline hover-hover:hover:text-blue-darkish active:underline active:text-blue-darkish
            focus:relative focus:outline-hidden active:shadow-inset-active focus:shadow-inset-focus"
            onclick={() => closeHeaderMenu()}
            tabindex={showDropdown ? '' : -1}
          >
            <span class="text-lg font-semibold text-left grow px-6 ml-8">{item.text}</span>
          </button>
        {:else}
          <BaseLink
            url={item.url}
            className="w-full flex items-center px-6 py-4 text-blue-cerulean hover-hover:hover:underline hover-hover:hover:text-blue-darkish active:underline active:text-blue-darkish
            focus:relative focus:outline-hidden active:shadow-inset-active focus:shadow-inset-focus"
            target={item.target}
            tabindex={showDropdown ? '' : -1}
          >
            <span class="text-lg font-semibold text-left grow px-6 ml-8">{item.text}</span>
          </BaseLink>
        {/if}
      {:else if item.event}
        <button
          class="w-full flex items-center px-6 py-5 text-blue-cerulean hover-hover:hover:underline hover-hover:hover:text-blue-darkish active:underline active:text-blue-darkish
          focus:relative focus:outline-hidden active:shadow-inset-active focus:shadow-inset-focus"
          onclick={() => actions(item.event)}
          tabindex={showDropdown ? '' : -1}
        >
          <span class="text-lg font-semibold text-left grow px-6 ml-8">{item.text}</span>
        </button>
      {/if}
    </li>
  {/each}
</ul>
